export default function Italy() {
  return (
    <>
      <h1 className='text-3xl text-center font-semibold mb-36'>
        Condizioni generali di contratto
      </h1>
      <div className='package'>
        La Società SMART SERVICES S.r.l., con sede in 20124 – Milano (MI), Via
        Pola n. 11, partita IVA n. <a href='tel:12220580968'>12220580968</a>,
        nella persona del suo legale rappresentante p.t., e-mail{' '}
        <a href='mailto:amministrazione@smartcaf.it'>
          amministrazione@smartcaf.it
        </a>
        , PEC{' '}
        <a href='mailto:smart.services@legalmail.it'>
          smart.services@legalmail.it
        </a>
        , nel prosieguo denominata{' '}
        <span className='font-bold'>&quot;Venditore&quot;</span>
      </div>

      <div className='package'>
        <h4>Premesso:</h4>
        <ul>
          <li>
            che il Venditore gestisce il sito www.smartcaf.it (d&apos;ora in
            avanti <span className='font-bold'>&quot;Sito&quot;</span>);
          </li>
          <li>
            che il sito è destinato a transazioni commerciali tra imprenditore e
            consumatore (B2C);
          </li>
          <li>
            che sul sito si realizza l&apos;incontro tra domanda e offerta dei
            servizi indicati al punto c) dell&apos;art. 1 ed è possibile
            concludere contratti di fornitura di servizi on line;
          </li>
          <li>
            che, con l&apos;espressione &quot;Condizioni Generali di
            Vendita&quot;, s&apos;intende il contratto di compravendita relativo
            ai servizi del Venditore stipulato tra questi e l’Acquirente
            nell&apos;ambito di un sistema di vendita di servizi a distanza
            organizzato dal Fornitore;
          </li>
          <li>
            che, per tale contratto, sarà impiegata la tecnologia di
            comunicazione a distanza attraverso la rete Internet;
          </li>
          <li>
            che l&apos;acquisto all&apos;interno del sito da parte dei clienti è
            regolato dalle presenti Condizioni Generali di Vendita;
          </li>
          <li>
            che l’Acquirente riveste lo status di consumatore, intendendosi per
            tale la persona fisica che compie l&apos;acquisto, di cui al
            presente contratto, per scopi non riferibili all&apos;attività
            commerciale o professionale eventualmente svolta;
          </li>
          <li>
            che questo contratto - e le condizioni previste - concernono
            esclusivamente la vendita B2C ad un Acquirente/Consumatore, come
            specificato alla linea precedente;
          </li>
          <li>
            che tutti i contratti saranno conclusi direttamente attraverso
            l&apos;accesso da parte dell&apos;Acquirente al sito Internet
            corrispondente all&apos;indirizzo www.smartcaf.it ove, seguendo le
            procedure indicate per accedere all&apos;area riservata del sito
            stesso dedicata alla negoziazione on line;
          </li>
          <li>
            che il marchio e il logo relativi al sito sono di esclusiva
            proprietà del Venditore;
          </li>
          <li>
            che nella stesura delle presenti Condizioni Generali si sono
            utilizzati termini di uso comune nell&apos;ambito delle tecnologie
            dell&apos;informazione e che, nel caso di eventuali divergenze sulla
            loro interpretazione o sul loro significato si terrà presente quanto
            contenuto nelle principali pubblicazioni della letteratura
            specializzata in materia;
          </li>
          <li>
            che le presenti premesse costituiscono parte integrante e
            sostanziale del contratto;
          </li>
        </ul>
      </div>

      <div className='package'>
        <h4>si conviene quanto segue:</h4>
        <h4>1. Definizioni</h4>

        <p>
          <span className='font-bold'>1.1</span> Nelle presenti Condizioni
          Generali di Contratto i seguenti termini hanno il significato qui di
          seguito specificato:
        </p>
        <p>
          a) per &quot;contratto di vendita on line&quot; si intende il
          contratto a distanza stipulato tra il Venditore ed un Acquirente
          consumatore finale, attraverso un sistema di vendita organizzato dal
          Venditore, che utilizza la tecnologia di comunicazione a distanza
          denominata internet;
        </p>
        <p>
          b) l&apos;espressione &quot;Fornitore&quot; si riferisce alla Società
          SMART SERVICES S.R.L., con sede in 20124 – Milano (MI), Via Pola n.
          11, C.F. e P IVA 12220580968, parte del presente contratto, che
          provvede alla gestione del Sito, vendendo direttamente agli utenti
          (Acquirenti) i Servizi indicati al punto che segue;
        </p>
        <p>
          c) l&apos;espressione &quot;Servizi&quot; si riferisce esclusivamente
          ai servizi presenti nei cataloghi elettronici del Sito;
        </p>
        <p>
          d) l&apos;espressione &quot;Acquirente&quot; si riferisce al
          consumatore finale-cliente che è autorizzato ad operare sul Sito al
          fine di acquistare i servizi, secondo le modalità indicate nelle
          presenti condizioni generali;
        </p>
        <p>
          e) per &quot;Consumatore&quot; s&apos;intende la persona fisica che
          acquista beni e servizi per scopi non riferibili, né direttamente, né
          mediatamente, all&apos;attività professionale eventualmente svolta.
        </p>
        <p>
          f) l&apos;espressione &quot;Parti&quot; si riferisce al Venditore e
          all&apos;Acquirente congiuntamente intesi;
        </p>
        <p>
          g) l&apos;espressione &quot;Sito&quot; si riferisce al sito internet
          corrispondente all&apos;indirizzo{' '}
          <a target='_blank' href='https://www.smartcaf.it'>
            https://www.smartcaf.it
          </a>{' '}
          tramite il quale è possibile effettuare acquisti on line;
        </p>
        <p>
          h) il termine &quot;Corrispettivo&quot; si riferisce al prezzo di
          vendita di ciascun prodotto;
        </p>
      </div>

      <div className='package'>
        <h4>2. Oggetto del contratto</h4>
        <p>
          <span className='font-bold'>2.1</span> Le presenti condizioni
          generali, che vengono messe nella disponibilità dell&apos;Acquirente
          per la riproduzione e conservazione ai sensi dell&apos;
          <a
            target='_blank'
            href='https://onelegale.wolterskluwer.it/normativa/10LX0000155316ART13?pathId=b82f680d60382'
          >
            art. 12
          </a>{' '}
          ,{' '}
          <a
            target='_blank'
            href='https://onelegale.wolterskluwer.it/normativa/10LX0000155316SOMM?pathId=b82f680d60382'
          >
            D.Lgs. 9 aprile 2003, n. 70
          </a>{' '}
          , hanno per oggetto l&apos;acquisto di prodotti, effettuato a distanza
          e per mezzo di rete telematica, tramite il Sito internet appartenente
          al Venditore, 20124 – Milano (MI), Via Pola n. 11, C.F. e P IVA
          <a href='tel:12220580968'>12220580968</a>
        </p>
        <p>
          <span className='font-bold'>2.2</span> Con il presente contratto,
          rispettivamente, il Venditore vende e l&apos;Acquirente acquista a
          distanza i beni mobili e/o servizi di seguito indicati.
        </p>
        <p>
          <span className='font-bold'>2.3</span> I servizi oggetto del presente
          contratto sono tutti i prodotti scelti dall&apos;Acquirente, seguendo
          le procedure di acquisto on line indicate nel sito.
        </p>
        <p>
          <span className='font-bold'>2.4</span> I prodotti e/o servizi di cui
          al punto precedente sono illustrati nelle pagine web alla sezione
          https://www.smartcaf.it/servizi del Sito del Venditore.
        </p>
        <p>
          <span className='font-bold'>2.5</span> Il Venditore si impegna a
          fornire tutti i servizi successivamente indicati dietro il pagamento
          di un corrispettivo di cui all&apos;art. 4 del presente contratto.
        </p>
      </div>

      <div className='package'>
        <h4>3. Accettazione delle condizioni di vendita</h4>

        <p>
          <span className='font-bold'>3.1</span> Le presenti condizioni generali
          sono valide dal giorno di conclusione del presente contratto e
          potranno essere aggiornate, integrate o modificate in qualsiasi
          momento dal Venditore, il quale provvederà a darne comunicazione
          tramite le pagine del Sito web e tali aggiornamenti/modifiche e/o
          integrazioni avranno efficacia per i futuri acquisti.
        </p>
        <p>
          <span className='font-bold'>3.2</span> Tutti gli ordini di acquisto
          saranno inoltrati dall&apos;acquirente al Venditore, previa
          registrazione al sito e digitazione di ID e PW con accesso in
          un&apos;area riservata tramite protocollo sicuro (https), e, quindi,
          attraverso il completamento della procedura di acquisto indicata.
        </p>
        <p>
          <span className='font-bold'>3.3</span> Le presenti condizioni generali
          di vendita devono essere esaminate &quot;on line&quot;
          dall&apos;Acquirente, prima del completamento della procedura di
          acquisto. L&apos;inoltro della conferma d&apos;ordine d&apos;acquisto,
          pertanto, implica totale conoscenza delle stesse e loro integrale
          accettazione.
        </p>
        <p>
          <span className='font-bold'>3.4</span> L&apos;Acquirente, inviando
          telematicamente la conferma del proprio ordine d&apos;acquisto,
          accetta incondizionatamente e si obbliga ad osservare, nei suoi
          rapporti con il Venditore le condizioni generali e di pagamento di
          seguito illustrate, dichiarando di aver preso visione ed accettando
          tutte le indicazioni da lui fornite ai sensi delle norme sopra
          richiamate, prendendo altresì atto che il Venditore non si ritiene
          vincolato a condizioni diverse se non preventivamente concordate per
          iscritto.
        </p>
        <p>
          <span className='font-bold'>3.5</span> Le operazioni di vendita sono
          regolate per il consumatore dalle disposizioni di cui al{' '}
          <a
            target='_blank'
            href='https://onelegale.wolterskluwer.it/normativa/10LX0000169414SOMM?pathId=b82f680d60382'
          >
            D.Lgs. 6 settembre 2005 n. 206
          </a>{' '}
          , mentre la tutela della riservatezza è sottoposta alla disciplina del{' '}
          <a
            target='_blank'
            href='https://onelegale.wolterskluwer.it/normativa/10LX0000156905SOMM?pathId=b82f680d60382'
          >
            D.Lgs. 30 giugno 2003, n. 196
          </a>{' '}
          , e successive modifiche ed integrazioni. Per quanto riguarda le
          condizioni contrattuali applicate agli utenti commerciali bisogna fare
          riferimento alle nuove disposizioni del{' '}
          <a
            target='_blank'
            href='https://onelegale.wolterskluwer.it/normativa/10LX0000879028SOMM?pathId=b82f680d60382'
          >
            Reg. UE 2019/1150
          </a>{' '}
          .
        </p>
        <p>
          Il{' '}
          <a
            target='_blank'
            href='https://onelegale.wolterskluwer.it/normativa/10LX0000156905SOMM?pathId=b82f680d60382'
          >
            D.Lgs. 30 giugno 2003, n. 196
          </a>{' '}
          è stato in ampia parte abrogato dal{' '}
          <a
            target='_blank'
            href='https://onelegale.wolterskluwer.it/normativa/10LX0000867502SOMM?pathId=b82f680d60382'
          >
            D.Lgs. 10 agosto 2018, n. 101
          </a>{' '}
          , che, a sua volta, adegua la disciplina interna al{' '}
          <a
            target='_blank'
            href='https://onelegale.wolterskluwer.it/normativa/10LX0000828463SOMM?pathId=b82f680d60382'
          >
            Regolamento UE n. 679/2016
          </a>
          , c.d. GDPR (General Data Protection Regulation in vigore dal 25
          maggio 2018). Dalla entrata in vigore del{' '}
          <a
            target='_blank'
            href='https://onelegale.wolterskluwer.it/normativa/10LX0000867502SOMM?pathId=b82f680d60382'
          >
            D.Lgs. 101/2018
          </a>{' '}
          i rinvii alle disposizioni del codice in materia di protezione dei
          dati personali, di cui al{' '}
          <a
            target='_blank'
            href='https://onelegale.wolterskluwer.it/normativa/10LX0000156905SOMM?pathId=b82f680d60382'
          >
            D.Lgs. 196/2003
          </a>
          , abrogate, contenuti in norme di legge e di regolamento, si intendono
          riferiti alle corrispondenti disposizioni del{' '}
          <a
            target='_blank'
            href='https://onelegale.wolterskluwer.it/normativa/10LX0000828463SOMM?pathId=b82f680d60382'
          >
            Regolamento UE 2016/679
          </a>{' '}
          e a quelle introdotte o modificate dal{' '}
          <a
            target='_blank'
            href='https://onelegale.wolterskluwer.it/normativa/10LX0000867502SOMM?pathId=b82f680d60382'
          >
            D.Lgs. 101/2018
          </a>
          , in quanto compatibili.
        </p>
        <p>
          <span className='font-bold'>3.6</span> L&apos;accettazione delle
          condizioni di vendita va manifestata tramite l&apos;esatta
          compilazione di tutte le sezioni del form elettronico, seguendo le
          istruzioni a video e, da ultimo, selezionando e, quindi, accettando le
          caselle con la dicitura ACCETTAZIONE CONDIZIONI DI VENDITA e
          INFORMATIVA PRIVACY.
        </p>
      </div>

      <div className='package'>
        <h4>4. Modalità d&apos;acquisto e prezzi di vendita</h4>
        <p>
          <span className='font-bold'>4.1</span> I servizi, i prezzi e le
          condizioni di vendita presenti sul Sito - nei limiti della loro
          disponibilità - sono espressi in euro e costituiscono per il
          consumatore offerta al pubblico.
        </p>
        <p>
          <span className='font-bold'>4.2</span> I prezzi di vendita, di cui al
          punto precedente, sono al netto dell’IVA e di ogni altra imposta,
          nonché del costo totale della spedizione sino al domicilio indicato
          dall&apos;Acquirente al momento dell&apos;ordine, purché il luogo di
          destinazione sia situato nel territorio italiano. In ogni caso, il
          costo totale della spedizione sino al domicilio dell&apos;Acquirente è
          a carico dello stesso, salvo eccezioni e deroghe che verranno
          appositamente pubblicizzate sul sito. Il costo viene, in ogni caso
          reso noto al cliente prima della conferma dell&apos;acquisto.
        </p>
        <p>
          <span className='font-bold'>4.3</span> Il prezzo del servizio indicato
          sul sito ha valore definitivo, salvo il caso in cui - per situazioni
          eccezionali - il Venditore consideri opportuno sottoporre il prezzo a
          revisione. Si considerano condizioni eccezionali, in via
          esemplificativa e non tassativa, il repentino e non concordato
          cambiamento di prezzo del servizio da parte del fornitore,
          l&apos;improvvisa variazione di tassi doganali o di cambi di valuta e
          comunque di spese di spedizione in generale. Nei casi eccezionali di
          revisione del prezzo, le Parti si impegnano espressamente a svolgere
          la rinegoziazione dello stesso attraverso uno scambio di e-mail
          secondo correttezza e buona fede, tenendo in considerazione la
          documentazione prodotta ed attestante le situazioni eccezionali che
          hanno comportato tale revisione.
        </p>
        <p>
          <span className='font-bold'>4.4</span> Il ricevimento dell&apos;ordine
          impegna il Venditore secondo il modello dell’offerta al pubblico ex.
          art. 1336 c.c.. Si precisa che all&apos;atto della ricezione
          dell&apos;ordine da parte dell&apos;Acquirente, il sistema invierà
          automaticamente una mail di riscontro riepilogativa dell&apos;ordine
          ricevuto, quale formale accettazione dello stesso.
        </p>
        <p>
          <span className='font-bold'>4.5</span> L&apos;Acquirente dichiara
          espressamente di compiere l&apos;acquisto dei servizi per fini
          estranei all&apos;attività commerciale o professionale eventualmente
          esercitata.
        </p>
      </div>

      <div className='package'>
        <h4>5. Conclusione del contratto</h4>
        <p>
          <span className='font-bold'>5.1</span> Il Contratto stipulato tramite
          il Sito si intende concluso nel momento in cui l&apos;Acquirente
          accetta l’offerta al pubblico ex. art. 1336 c.c. del Venditore ed
          invia l’ordine al termine della procedura di acquisto; in seguito il
          Venditore invia una e-mail automatica e riepilogativa dell&apos;ordine
          di cui all&apos;art. 4.4, attraverso la quale il Venditore lo informa
          circa le modalità di erogazione dei servizi. Il Contratto si conclude
          nel luogo in cui è situata la sede legale del Venditore.
        </p>
      </div>

      <div className='package'>
        <h4>Art. 6. Modalità di erogazione dei Servizi</h4>
        <p>
          <span className='font-bold'>6.1</span> Il Fornitore provvederà ad
          erogare i Servizi acquistati con le modalità indicate sul Sito al
          momento dell’offerta del Servizio e confermate a mezzo e-mail.
        </p>
        <p>
          <span className='font-bold'>6.2</span> I Servizi offerti dal Fornitore
          sono indicati all’interno del Sito.
        </p>
        <p>
          <span className='font-bold'>6.3</span> Ciascun Servizio acquistato dal
          Cliente prevede ed è caratterizzato da una serie di fasi di
          elaborazione come di seguito specificate:
        </p>
        <ul className='ml-16'>
          <li>
            <span>Da Elaborare</span> (il Fornitore ha ricevuto la richiesta del
            Servizio da parte del Cliente ma non ha ancora iniziato ad
            elaborarlo;
          </li>
          <li>
            <span>In Elaborazione</span> (il Fornitore sta elaborando la pratica
            connessa al Servizio);
          </li>
          <li>
            <span>Info Mancante</span> (manca un documento o un’informazione che
            il Cliente dovrà comunicare e/o consegnare al Fornitore per
            permettergli di completare l’erogazione del Servizio);
          </li>
          <li>
            <span>Completo</span> (servizio completato e consegnato).
          </li>
        </ul>

        <p>
          <span className='font-bold'>6.4</span> Una volta che il Servizio
          raggiungerà lo status “completo”, il Venditore provvederà a consegnare
          all’Acquirente le ricevute inerenti ai servizi erogati ed acquistati
          mediante caricamento nell’area riservata sul Sito ed a mezzo di
          contestuale invio di e-mail.
        </p>
        <p>
          <span className='font-bold'>6.5</span> Qualora per il servizio erogato
          vi sia la necessità di consegnare documentazione in formato cartaceo,
          il Venditore provvederà a recapitare all&apos;Acquirente, presso
          l&apos;indirizzo indicato da questi la documentazione con le modalità
          previste dai precedenti articoli, mediante corrieri e/o spedizionieri
          di fiducia. La consegna avverrà entro 10 giorni lavorativi, così come
          indicato nella conferma dell&apos;ordine.
        </p>
        <p>
          <span className='font-bold'>6.6</span> Ove l&apos;Acquirente sia
          assente, verrà lasciato un avviso con le indicazioni necessarie per
          contattare il corriere o lo spedizioniere al fine di concordare le
          modalità di consegna.
        </p>
        <p>
          <span className='font-bold'>6.7</span> Nessuna responsabilità potrà
          essere attribuita al Venditore per ritardata o mancata consegna
          imputabile a cause di forza maggiore o caso fortuito.
        </p>
        <p>
          <span className='font-bold'>6.8</span> All&apos;atto del ricevimento,
          l&apos;Acquirente è tenuto a verificare la conformità di quanto a lui
          consegnato con l&apos;ordine effettuato; solo dopo tale verifica si
          dovrà procedere alla sottoscrizione dei documenti di consegna, salvo
          ovviamente il diritto di recesso previsto all&apos;art. 10 delle
          presenti condizioni. Resta escluso il diritto di recesso ove i beni
          venduti siano fatti &quot; su misura&quot; al cliente.
        </p>
        <p>
          <span className='font-bold'>6.9</span> È facoltà dell&apos;Acquirente
          scegliere un altro vettore, restando ovviamente inteso che anche in
          tal caso il trasporto avverrà a suo esclusivo rischio, cura e spese, e
          che il pagamento dovrà avvenire in maniera anticipata rispetto alla
          consegna.
        </p>
      </div>

      <div className='package'>
        <h4>Art. 7. Responsabilità</h4>
        <p>
          <span className='font-bold'>7.1</span> Il Venditore non assume alcuna
          responsabilità per il ritardo o la mancata consegna del bene e/o
          servizio imputabile a causa di forza maggiore quali incidenti,
          esplosioni, incendi, scioperi e/o serrate, terremoti, alluvioni,
          pandemie, ed altri similari eventi che impedissero, in tutto o in
          parte, di dare esecuzione nei tempi concordati al contratto.
        </p>
        <p>
          <span className='font-bold'>7.2</span> Il Venditore non sarà
          responsabile nei confronti di alcuna parte o di terzi in merito a
          danni, perdite e costi subiti a seguito della mancata esecuzione del
          contratto per le cause sopra citate, avendo il consumatore diritto
          soltanto alla restituzione del prezzo eventualmente corrisposto.
        </p>
        <p>
          <span className='font-bold'>7.3</span> Il Venditore garantisce che i
          Servizi presenti all&apos;interno dei cataloghi elettronici sono
          liberamente acquistabili. In ogni caso si applicano le norme del
          codice civile italiano in tema di compravendita.
        </p>
      </div>

      <div className='package'>
        <h4>Art. 8. Obblighi dell&apos;Acquirente</h4>
        <p>
          <span className='font-bold'>8.1</span> L&apos;acquirente si impegna e
          si obbliga, una volta conclusa la procedura d&apos;acquisto, a
          provvedere alla stampa ed alla conservazione delle presenti condizioni
          generali, che, peraltro, avrà già visionato ed accettato in quanto
          passaggio obbligato nell&apos;acquisto, nonché delle specifiche del
          prodotto oggetto dell&apos;acquisto, e ciò al fine di soddisfare
          integralmente la condizione di cui al{' '}
          <a
            target='_blank'
            href='https://onelegale.wolterskluwer.it/normativa/10LX0000169414SOMM?pathId=b82f680d60382'
          >
            D.Lgs. 6 settembre 2005, n. 206
          </a>{' '}
          .
        </p>
        <p>
          <span className='font-bold'>8.2</span> È fatto severo divieto
          all&apos;Acquirente di inserire dati falsi, e/o inventati, e/o di
          fantasia, nella procedura di registrazione attraverso l&apos;apposito
          form elettronico ed all’interno del form elettronico relativo ai dati
          necessari per l’erogazione del Servizio; i dati anagrafici e la e-mail
          devono essere esclusivamente i propri reali dati personali e non di
          terze persone, oppure di fantasia. L&apos;Acquirente si assume,
          pertanto, la piena responsabilità circa l&apos;esattezza e la
          veridicità dei dati immessi nel form elettronico di registrazione ed
          all’interno del form elettronico relativo ai dati necessari per
          l’erogazione del Servizio, finalizzati a completare la procedura di
          acquisto dei prodotti.
        </p>
        <p>
          <span className='font-bold'>8.3</span> È espressamente vietato
          effettuare doppie registrazioni corrispondenti ad una sola persona o
          inserire dati di terze persone. Il Venditore si riserva di perseguire
          legalmente ogni violazione ed abuso, nell&apos;interesse e per la
          tutela dei consumatori tutti.
        </p>
        <p>
          <span className='font-bold'>8.4</span> L&apos;Acquirente manleva il
          Venditore da ogni responsabilità derivante dall&apos;emissione di
          documenti fiscali errati a causa di errori relativi ai dati forniti
          dall&apos;Acquirente, essendone quest&apos;ultimo l&apos;unico
          responsabile del corretto inserimento.
        </p>
      </div>

      <div className='package'>
        <h4>Art. 9. Diritto di recesso</h4>
        <p>
          <span className='font-bold'>9.1</span> a norma degli artt.64 e 67 del
          D.Lgs. 6 settembre 2005, n. 206, l’Acquirente può esercitare il
          diritto di recesso dal Servizio prima che questo sia stato fornito,
          anche solo in parte, ricevendo in tale caso il rimborso delle somme a
          suo tempo corrisposte tramite il Sito.
        </p>
        <p>
          <span className='font-bold'>9.2</span> Nella ipotesi di cui al comma
          precedente, l’Acquirente ha diritto di recedere dal contratto
          stipulato, senza alcuna penalità e senza specificarne il motivo, entro
          il termine di 14 giorni decorrenti dal giorno della conclusione del
          contratto.
        </p>
        <p>
          <span className='font-bold'>9.3</span> Per esercitare il diritto di
          recesso l’Acquirente dovrà, entro il termine indicato al punto 9.2,
          inviare lettera raccomandata con ricevuta di ritorno al seguente
          indirizzo: 20124 – Milano (MI), Via Pola n. 11. Entro lo stesso
          termine può essere inviata una e-mail all’indirizzo{' '}
          <a href='mailto:smart.services@legalmail.it'>
            smart.services@legalmail.it
          </a>
          .
        </p>
        <p>
          <span className='font-bold'>9.4</span> Se l’esecuzione del Servizio da
          parte del Venditore è iniziata prima dello scadere del termine di cui
          al punto 2.2, l’Acquirente potrà recedere dal contratto unicamente
          laddove la pratica connessa al servizio acquistato sia ancora da
          elaborare. In tal caso all’interno della propria area personale
          l’Acquirente troverà in corrispondenza del Servizio acquistato per il
          quale intende chiedere il recesso lo status “da elaborare”. Laddove la
          pratica connessa al Servizio risulti essere in uno stato successivo, e
          quindi in fase di elaborazione, l’Acquirente perderà il diritto di
          recesso ed ogni diritto al rimborso del corrispettivo già versato.
        </p>
        <p>
          <span className='font-bold'>9.6</span> All’Acquirente che eserciti il
          diritto di recesso conformemente a quanto stabilito saranno rimborsate
          le somme già versate, secondo le regole di cui ai punti precedenti,
          entro il termine di 15 giorni, e comunque non oltre 30 giorni a
          partire dalla data in cui il Venditore è venuto a conoscenza
          dell&apos;esercizio del diritto di recesso da parte del
          Cliente/Consumatore.
        </p>
      </div>

      <div className='package'>
        <h4>Art. 10. Risoluzione del contratto</h4>
        <p>
          <span className='font-bold'>10.1</span> Le parti convengono che il
          contratto si risolverà di diritto in seguito al verificarsi di uno
          degli inadempimenti di seguito elencati:
        </p>
        <ul>
          <li>
            violazione degli obblighi di cui all&apos;art. 4 (Modalità
            d&apos;acquisto e prezzi di vendita);
          </li>
          <li>
            violazione degli obblighi di cui all&apos;art. 7 (Responsabilità);
          </li>
          <li>
            violazione degli obblighi di cui all&apos;art. 8 (Obblighi
            dell&apos;Acquirente):
          </li>
          <li>
            violazione degli obblighi di cui all&apos;art. 15 (Divieto di
            cessione).
          </li>
        </ul>
        <p>
          <span className='font-bold'>10.2</span> Ai sensi dell&apos;
          <a
            target='_blank'
            href='https://onelegale.wolterskluwer.it/document/05AC00002808?pathId=b82f680d60382'
          >
            art. 1456
          </a>{' '}
          c.c., la parte che intenda avvalersi della risoluzione ne darà
          comunicazione alla controparte mediante invio di raccomandata a/r o
          PEC (Posta Elettronica Certificata), indicando la motivazione; gli
          effetti della risoluzione decorrono dalla data di ricezione della
          comunicazione di risoluzione risultante dalla ricevuta riconsegnata
          alla Parte che risolve e l&apos;Acquirente avrà diritto esclusivamente
          alla restituzione dell&apos;eventuale somma già corrisposta.
        </p>
      </div>

      <div className='package'>
        <h4>Art. 11 Comunicazioni</h4>
        <p>
          <span className='font-bold'>11.1</span> Fatti salvi i casi
          espressamente indicati - ovvero stabiliti da obblighi di legge - le
          comunicazioni tra il Venditore e l&apos;Acquirente avranno luogo
          preferibilmente per il tramite di messaggi e-mail ai rispettivi
          indirizzi elettronici che saranno da entrambe le parti considerati
          valido mezzo di comunicazione e la cui produzione in giudizio non
          potrà essere oggetto di contestazione per il solo fatto di essere
          documenti informatici.
        </p>
        <p>
          <span className='font-bold'>11.2</span> Entrambe le parti potranno in
          qualsivoglia momento cambiare il proprio indirizzo e-mail ai fini del
          presente articolo, purché ne diano tempestiva comunicazione
          all&apos;altra parte nel rispetto delle forme stabilite dal comma
          precedente.
        </p>
      </div>

      <div className='package'>
        <h4>Art. 12. Trattamento dei dati personali</h4>
        <p>
          <span className='font-bold'>12.1</span> L&apos;Acquirente dichiara
          espressamente di aver preso visione sia dell&apos;informativa prevista
          dall&apos;
          <a
            target='_blank'
            href='https://onelegale.wolterskluwer.it/normativa/10LX0000156905ART14?pathId=b82f680d60382'
          >
            art. 13
          </a>{' '}
          del{' '}
          <a
            target='_blank'
            href='https://onelegale.wolterskluwer.it/normativa/10LX0000156905SOMM?pathId=b82f680d60382'
          >
            D.Lgs. 30 giugno 2003, n. 196
          </a>{' '}
          (Codice Privacy), sia della &quot;privacy policy&quot; del Sito. A
          seguito dell’abrogazione del{' '}
          <a
            target='_blank'
            href='https://onelegale.wolterskluwer.it/normativa/10LX0000156905SOMM?pathId=b82f680d60382'
          >
            D.Lgs. 30 giugno 2003, n. 196
          </a>{' '}
          da parte del{' '}
          <a
            target='_blank'
            href='https://onelegale.wolterskluwer.it/normativa/10LX0000867502SOMM?pathId=b82f680d60382'
          >
            D.Lgs. 10 agosto 2018, n. 101
          </a>{' '}
          i rinvii alle disposizioni del{' '}
          <a
            target='_blank'
            href='https://onelegale.wolterskluwer.it/normativa/10LX0000156905SOMM?pathId=b82f680d60382'
          >
            D.Lgs. 196/2003
          </a>{' '}
          , abrogate, si intendono riferiti alle corrispondenti disposizioni del{' '}
          <a
            target='_blank'
            href='https://onelegale.wolterskluwer.it/normativa/10LX0000828463SOMM?pathId=b82f680d60382'
          >
            Regolamento UE 2016/679
          </a>{' '}
          e a quelle introdotte o modificate dal{' '}
          <a
            target='_blank'
            href='https://onelegale.wolterskluwer.it/normativa/10LX0000867502SOMM?pathId=b82f680d60382'
          >
            D.Lgs. 101/2018
          </a>
          , in quanto compatibili.
        </p>
        <p>
          <span className='font-bold'>12.2</span> I diritti derivanti dalla
          normativa sulla privacy e gli obblighi di informativa da essa nascenti
          a carico del Venditore sono esaminati &quot;on line&quot;, prima del
          completamento della procedura di acquisto. L&apos;inoltro della
          conferma d&apos;ordine pertanto implica totale conoscenza degli
          stessi.
        </p>
        <p>
          <span className='font-bold'>12.3</span> Il Titolare della raccolta e
          del trattamento dei dati personali è SMART SERVICES S.r.l., come sopra
          specificato, nella persona del suo legale rappresentante pro tempore,
          sig. . I diritti di cui all&apos;articolo 7 sono esercitati con
          richiesta rivolta senza formalità al titolare, inviando una semplice
          e-mail all&apos;indirizzo del Venditore, il quale è tenuto a fornire
          la comunicazione delle eventuali variazioni ai propri dati allo stesso
          indirizzo.
        </p>
      </div>

      <div className='package'>
        <h4>Art. 13. Divieto di cessione</h4>
        <p>
          <span className='font-bold'>13.1</span> Il contratto non è cedibile a
          terzi a pena dell&apos;immediata risoluzione dello stesso.
        </p>
      </div>

      <div className='package'>
        <h4>Art. 14. Giurisdizione e Foro competente</h4>
        <p>
          <span className='font-bold'>14.1</span> Ogni controversia relativa
          all’applicazione, esecuzione, interpretazione e violazione dei
          contratti d&apos;acquisto stipulati &quot;on line&quot; tramite il
          Sito web del Venditore è sottoposta alla giurisdizione italiana, anche
          secondo quanto previsto dall&apos;
          <a
            target='_blank'
            href='https://onelegale.wolterskluwer.it/normativa/10LX0000190496ART4?pathId=b82f680d60382'
          >
            art. 3
          </a>
          ,{' '}
          <a
            target='_blank'
            href='https://onelegale.wolterskluwer.it/normativa/10LX0000190496SOMM?pathId=b82f680d60382'
          >
            Conv. 19 giugno 1980, n. 80/934/CEE
          </a>{' '}
          (Convenzione di Roma), sulla legge applicabile alle obbligazioni
          contrattuali; le presenti condizioni generali si riportano, per quanto
          non espressamente ivi previsto, al{' '}
          <a
            target='_blank'
            href='https://onelegale.wolterskluwer.it/normativa/10LX0000169414SOMM?pathId=b82f680d60382'
          >
            D.Lgs. 6 settembre 2005, n. 206
          </a>{' '}
          (Codice del Consumo).
        </p>
        <p>
          <span className='font-bold'>14.2</span> In caso di controversie
          derivanti dal presente contratto o ad esso collegate, le parti si
          impegnano a cercare tra loro un equo e bonario componimento.
        </p>
        <p>
          <span className='font-bold'>14.3</span> Qualora la controversia non
          sia stata risolta bonariamente, e comunque entro sei mesi dalla data
          del suo inizio, la stessa sarà portata alla cognizione esclusiva del
          Foro nel cui circondario ha il proprio domicilio
          l&apos;Acquirente/Consumatore secondo quanto previsto dal D.Lgs.
          206/05 ; nell&apos;ipotesi in cui l&apos;Acquirente non rivesta lo
          status di consumatore finale si conviene che ogni controversia, anche
          in deroga alle norme relative alla competenza territoriale, sarà di
          esclusiva competenza del Foro di Milano.
        </p>
      </div>

      <div className='package'>
        <h4>Art. 15. Clausole finali</h4>
        <p>
          <span className='font-bold'>15.1</span> Il presente contratto abroga e
          sostituisce ogni accordo, intesa, negoziazione, scritta od orale,
          intervenuta in precedenza tra le parti e concernente l&apos;oggetto di
          questo contratto.
        </p>
      </div>

      <div className='package'>
        <h4>Art. 16. Legge applicabile e rinvio.</h4>
        <p>
          <span className='font-bold'>16.1</span> - Il presente contratto è
          regolato dalla legge italiana.
        </p>
        <p>
          <span className='font-bold'>16.2</span> - Per quanto qui non
          espressamente disposto valgono le norme di legge applicabili ai
          rapporti e alle fattispecie previste nel presente contratto e, in ogni
          caso, le norme del Codice Civile e del{' '}
          <a
            target='_blank'
            href='https://onelegale.wolterskluwer.it/normativa/10LX0000169414SOMM?pathId=b82f680d60382'
          >
            D.Lgs. 6 settembre 2005, n. 206
          </a>{' '}
          (Codice del Consumo).
        </p>
      </div>
    </>
  )
}
